//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import resetPhone from '@/views/sys/user-info/reset-phone';
import resetPsw from '@/views/sys/user-info/reset-psw';
export default {
    components: { resetPhone, resetPsw },
    props: [],
    data() {
        return {
            menuList: [],
        };
    },
    computed: {
        user() {
            return this.$store.getters.getUser;
        },
    },
    methods: {
        logoutHandler() {
            this.$store.dispatch('logout');
        },
        queryMenu() {
            this.$get(this.getStore('sysUrl') + '/menu/list', (data) => {
                this.menuList = data;

                var menuArr = treeBreakArr(data);

                if (
                    menuArr.array.some((item) => item.url === '/tw/audit/list')
                ) {
                    this.setStore({
                        isAuditer: true,
                    });
                }
            });
        },
        handleCommand(e) {
            var that = this,
                switchObj = {
                    rphone() {
                        that.$refs.rphone.show();
                    },
                    rpsw() {
                        that.$refs.rpsw.show();
                    },
                };

            switchObj[e]();
        },
    },
    mounted: function () {
        var user = this.$store.state.user;

        if (!user) {
            this.$store.dispatch('queryUserInfo');
        }

        this.queryMenu();

        // $('.home-header').css('background','url('+ webInfo.logoUrl +')');
        // $('.home-header').css('background-repeat','no-repeat');
        // $('.home-header').css('background-position','-12px 15px');
    },
};
